var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 104,
    viewBox: "0 0 121 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.3078 3.41997L70.6186 73.4608C70.4664 74.3424 69.9794 75.0264 69.1575 75.5128C68.7313 75.756 68.2595 75.8776 67.742 75.8776C67.4071 75.8776 67.0419 75.8016 66.6461 75.6496L45.9618 67.2137L34.9118 76.9512C34.3639 77.6504 33.6181 78 32.6745 78C32.2787 78 31.9439 77.9392 31.6699 77.8176C31.0916 77.6048 30.6273 77.2476 30.2773 76.746C29.9272 76.2444 29.7522 75.6896 29.7522 75.0816V62.8818L52.9263 33.6226L20.3917 56.7714L2.35568 49.3843C1.22937 48.9587 0.620566 48.1227 0.529243 46.8763C0.468362 45.6603 0.955406 44.7635 1.99039 44.1859L77.97 0.410396C78.4266 0.136797 78.9137 0 79.4312 0C80.04 0 80.5879 0.167197 81.0749 0.501595C82.0795 1.23119 82.4904 2.20397 82.3078 3.41997Z",
    fill: "#CECECE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6491 100C106.471 100 116.875 89.6181 116.875 76.8C116.875 63.9819 106.471 53.6 93.6491 53.6C80.827 53.6 70.4233 63.9819 70.4233 76.8C70.4233 89.6181 80.827 100 93.6491 100Z",
    fill: "#CECECE",
    stroke: "white",
    strokeWidth: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3757 77.3529L90.3936 83.9058L103.338 70.8",
    stroke: "white",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSuccess);
export default __webpack_public_path__ + "static/media/message-success.dd2611d0ca48ac0f2dfb90c5e6ae1771.svg";
export { ForwardRef as ReactComponent };